import {EventEmitter} from "./EventEmitter";
import {translator} from "../services/TranslatorService";
import {dateHelper} from "../helpers/dateHelper";

/**
 * Класс для работы с фильтром на афише
 */
export class EventFilter {
	constructor() {
		this.emitter = new EventEmitter();

		this.$filterClear = $("#js-filter-clear");

		this.$message = $("#js-events-message");
		this.$eventItems = $("#js-event-items");

		this.$more = $(".js-more");

		this.$dateInputs = $(".js-date-input");
		this.$dateInputFirst = $(".js-date-input-first");
		this.$dateInputSecond = $(".js-date-input-second");
		this.$commonEmpty = $("#js-common-empty");

		/* Инициализация фильтра с параметрами */
		this.init();
	}

	init() {
		this.setUpSubscribers();
		this.setUpListeners();
	}

	setUpSubscribers() {
		this.emitter.subscribe("event:clear-filter", () => {
			this.$dateInputFirst.val(dateHelper.toDateInputValue());
			this.$dateInputSecond.val("");
		});
	}

	setUpListeners() {
		this.$more.on("click", e => this.emitter.emit("event:click-load-more", $(e.currentTarget)));

		this.$filterClear.on("click", () => this.emitter.emit("event:clear-filter"));

		this.$dateInputs.on("change", e => {
			if (this.$dateInputFirst.val() === "" && this.$dateInputSecond.val() === "")
				return this.emitter.emit("event:clear-date-range");
			let firstDate = this.formatDate(this.$dateInputFirst.val());
			let secondDate = this.formatDate(this.$dateInputSecond.val());

			if (!this.$dateInputFirst.val() && this.$dateInputSecond.val()) {
				const today = new Date();
				const day = String(today.getDate()).padStart(2, "0");
				const month = String(today.getMonth() + 1).padStart(2, "0");

				const currentYear = today.getFullYear();
				firstDate = `${day}-${month}-${currentYear}`;
			}

			if (this.$dateInputFirst.val() && !this.$dateInputSecond.val()) {
				const nextTwoYears = new Date().getFullYear() + 2;
				secondDate = `12-12-${nextTwoYears}`;
			}

			this.emitter.emit("event:setup-date-range", {
				firstDate,
				secondDate,
			});
		});

		$("#js-filter-title").on("click", e => {
			$(e.currentTarget).toggleClass("active");
			if (!$(e.currentTarget).hasClass("active")) {
				$(".daterangepicker").addClass("d-none");
			} else {
				$(".daterangepicker").removeClass("d-none");
				$(".daterangepicker").css("display", "none");
			}
			return $("#js-filter-wrapper").slideToggle();
		});
	}

	/** *****************************************
	 * Методы которые предоставляет компонент:  *
	 * ******************************************
	 */

	/**
	 * Устанавливает подписчиков на событие
	 * @param action {String}
	 * @param fn {Function}
	 */
	on(action, fn) {
		if (action === "setup-date-range") {
			this.emitter.subscribe("event:setup-date-range", data => fn(data));
		}
		if (action === "clear-date-range") {
			this.emitter.subscribe("event:clear-date-range", () => fn());
		}
		if (action === "change-dropdown-input") {
			this.emitter.subscribe("event:change-dropdown-input", data => fn(data));
		}
		if (action === "reset-dropdown-filter") {
			this.emitter.subscribe("event:reset-dropdown-filter", type => fn(type));
		}
		if (action === "click-load-more") {
			this.emitter.subscribe("event:click-load-more", data => fn(data));
		}
		if (action === "clear-filter") {
			this.emitter.subscribe("event:clear-filter", () => fn());
		}
	}

	/**
	 * Инициализирует работу с выпадающими списками
	 * Добавляет события для чекбоксов
	 *
	 * @example Пример как использовать:
	 * EventFilter.initDropdownFilters(); - Инициализируем в js
	 * EventFilter.on("change-dropdown-input", data => {}); - Вешаем обработчики
	 *
	 * <div class="js-dropdown-filter" data-select="[unit, nom, all,...]">
	 *    <input type="checkbox" data-select="Ак Барс Арена" data-id="257">
	 *    ...
	 * </div>
	 */
	initDropdownFilters() {
		$(".js-dropdown-filter input[type=checkbox]").on("change", e => {
			const element = $(e.currentTarget);
			const id = element.data("id");
			const select = element.data("select");
			const type = element.closest(".js-dropdown-filter").data("select");

			const data = {element, id, isChecked: element.is(":checked"), type, select};

			this.changeDropdownBtnText({
				dropdown: element.closest(".js-dropdown-filter"),
				count: $(`.js-dropdown-filter[data-select=${type}] input[type=checkbox]:checked`)
					.length,
			});

			return this.emitter.emit("event:change-dropdown-input", data);
		});

		$(".js-dropdown-filter-reset").on("click", e => {
			const dropdownFilter = $(e.currentTarget).closest(".js-dropdown-filter");
			const type = dropdownFilter.data("select");

			dropdownFilter
				.find("input[type=checkbox]")
				.prop("checked", false)
				.removeClass("checked");

			this.changeDropdownBtnText({
				dropdown: dropdownFilter,
				count: 0,
			});

			return this.emitter.emit("event:reset-dropdown-filter", type);
		});

		/* При очистке фильтра также очищаем выпадающие списки */
		this.emitter.subscribe("event:clear-filter", () => {
			$(".js-dropdown-filter input[type=checkbox]")
				.prop("checked", false)
				.removeClass("checked");

			$(".js-dropdown-types input[type=checkbox]")
				.prop("checked", false)
				.removeClass("checked");

			$.each($(".js-dropdown-filter"), (i, dropdownFilter) =>
				this.changeDropdownBtnText({
					dropdown: dropdownFilter,
					count: 0,
				})
			);

			$.each($(".js-dropdown-types"), (i, dropdownFilter) =>
				this.changeDropdownBtnText({
					dropdown: dropdownFilter,
					count: 0,
				})
			);
		});
	}

	/**
	 * Инициализирует работу с типами мероприятии (Матчи, Абонементы, Услуги)
	 *
	 * @example Пример как использовать: EventFilter.initDropdownTypes(); - Инициализируем в js
	 */
	initDropdownTypes() {
		const checkboxList = $(".js-dropdown-types input[type=checkbox]");

		checkboxList.on("change", e => {
			const element = $(e.currentTarget);
			const id = element.data("id");
			const select = element.data("select");
			const type = element.closest(".js-dropdown-types").data("select");
			const count = $(`.js-dropdown-types[data-select=${type}] input[type=checkbox]:checked`)
				.length;

			this.changeDropdownBtnText({
				dropdown: element.closest(".js-dropdown-types"),
				count,
			});
			this.$commonEmpty.hide();

			/* Если ничего не выбрано то показываем все мероприятия */
			if (!checkboxList.is(":checked")) {
				$(".events_main").each(function () {
					if ($(this).find(".js-items").children().length) {
						$(this).show();
					}
				});
			} else {
				$.each(checkboxList, (i, el) => {
					const type = $(el).data("select");
					const currentEvents = $(`.events_main[data-type="${type}"]`);

					if (el.checked) {
						currentEvents.show();
					} else {
						currentEvents.hide();
					}
				});
			}

			let visibleCount = 0;

			$(".events_main").each(function () {
				if ($(this).find(".js-items").children().length && $(this).is(":visible")) {
					visibleCount++;
				} else {
					$(this).hide();
				}
			});

			if (!visibleCount) this.$commonEmpty.show();
			const data = {element, id, isChecked: element.is(":checked"), type, select};
			const countFilters = $(`.js-dropdown-filter input[type=checkbox]:checked`).length;
			this.$filterClear.removeClass("active");
			if (count || countFilters) this.$filterClear.addClass("active");
		});

		$(".js-dropdown-types-reset").on("click", e => {
			checkboxList.prop("checked", false);
			const dropdownFilter = $(e.currentTarget).closest(".js-dropdown-types");
			const type = dropdownFilter.data("select");

			this.changeDropdownBtnText({
				dropdown: dropdownFilter,
				count: 0,
			});

			$(".events_main").show();

			return this.emitter.emit("event:reset-dropdown-filter", type);
		});

		/* При очистке фильтра также очищаем выпадающие списки */
		this.emitter.subscribe("event:clear-filter", () => {
			checkboxList.prop("checked", false);

			return $(".events_main").show();
		});
	}

	/**
	 * Показывает отфильтрованные мероприятия на странице
	 * @param params {Object}
	 */
	showFilteredEvents({html, page, eventsCount, hasAnyAppliedParam, limit}) {
		if (eventsCount > 0) {
			this.$message.hide();
		} else {
			this.$message.text(translator.t("event", "No active events")).show();
		}

		/* если задействовали пагинацию то просто выводим снизу */
		if (parseInt(page) > 0) {
			this.$eventItems.append(html);
		} else {
			this.$eventItems.html(html);
		}

		if (hasAnyAppliedParam) {
			this.$filterClear.addClass("active");
		} else {
			this.$filterClear.removeClass("active");
		}

		this.renderLoadMoreBtn(eventsCount, limit);
	}

	/**
	 * Показывает отфильтрованные мероприятия на странице по типу
	 * @param params {Object}
	 */
	showFilteredEventsByType(res, {type, needClear, limit, dateRange}) {
		if (type) {
			const response = res[type];
			const provider = $(`#js-${type}-provider`);
			if (response) this.filteredFunction(provider, type, response, needClear, limit);
			return false;
		}
		let count = 0;
		for (const [key, value] of Object.entries(res)) {
			const provider = $(`#js-${key}-provider`);
			if (!value) continue;
			if (value.count) count++;
			this.filteredFunction(provider, key, value, needClear, limit, dateRange);
		}
		this.$commonEmpty.hide();

		let visibleCount = 0;
		$(".events_main").each(function () {
			if ($(this).is(":visible")) {
				visibleCount++;
			}
		});

		if (!count || !visibleCount) this.$commonEmpty.show();
	}

	filteredFunction(provider, key, value, needClear, limit, dateRange) {
		const {count, html, page} = value;
		const $items = provider.find(".js-items");
		let $moreButton = provider.find(".js-events-more-btn-wrapper");
		if (!($moreButton.length > 0)) {
			//добавляет обратную совместимость для старой версии
			$moreButton = provider.find(".events__more");
		}

		/* если задействовали пагинацию то просто выводим снизу */
		parseInt(page) > 0 ? $items.append(html) : $items.html(html);

		provider.show();

		if (count <= 0 && !$.trim($items.html())) provider.hide();

		$moreButton.hide();

		if (count > limit) $moreButton.show();
		const countCategories = $(`.js-dropdown-types input[type=checkbox]:checked`).length;
		const countFilters = $(`.js-dropdown-filter input[type=checkbox]:checked`).length;

		if (countCategories) {
			if (!$(`.js-dropdown-types input[data-select="${key}"]:checked`).length)
				provider.hide();
		}
		if (!needClear || countCategories || countFilters || dateRange) {
			this.$filterClear.addClass("active");
		} else {
			this.$filterClear.removeClass("active");
			provider.show();
		}

		this.renderLoadMoreBtn(count, limit, $moreButton);
	}

	renderLoadMoreBtn(eventsCount, limit, moreButton = this.$more) {
		if (!limit) return moreButton.addClass("inactive");

		if (eventsCount > limit) {
			moreButton.removeClass("inactive");
		} else {
			moreButton.addClass("inactive");
		}
	}

	changeDropdownBtnText({dropdown, count}) {
		const dropdownButton = $(dropdown).find("button[data-text]");

		if (count > 0) {
			dropdownButton.find(".filter__selected-text").text($(dropdownButton).data("text"));
			dropdownButton.find(".filter__selected-count").addClass("active").text(count);
		} else {
			dropdownButton.find(".filter__selected-text").text($(dropdownButton).data("previous"));
			dropdownButton.find(".filter__selected-count").removeClass("active").text(0);
		}
	}

	formatDate(value) {
		const splitValue = value.split("-");
		const [year, month, day] = splitValue;
		return `${day}-${month}-${year}`;
	}
}
